/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Speaker_IdInputs */



/**
* | output |
* | --- |
* | "Automatic Speaker Identification" |
*
* @param {Automatic_Speaker_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_speaker_id = /** @type {((inputs?: Automatic_Speaker_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Speaker_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Identification automatique des intervenants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Sprechererkennung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Identificazione automatica dell'altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая идентификация говорящего")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación automática del hablante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动说话人识别")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動話者識別")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित स्पीकर पहचान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Identificação automática de locutores")
	return /** @type {LocalizedString} */ ("Automatic Speaker Identification")
});